export const KEY_FLEXESERVEZONES = 'ST_NUTTALL_ZONES';
